import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CompiereMenu } from '@compiere-ws/models/compiere-menu-json';
import { AppConfig } from '@iupics-config/app.config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompiereMenuService {
  private url: string;

  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {}

  getMenus(): Observable<CompiereMenu[]> {
    this.url = this.config.getBackendResource('menu');
    return this.http.get<CompiereMenu[]>(this.url);
  }
}
